export default __webpack_public_path__ + "static/retail-vote-click-ab40ae0254dc0051f970323f51b11758.gif";